/**
 * 远程连接链接解析工具模块。
 */

/**
 * 验证是否为有效的 base64 字符串
 * @param {string} str - 要验证的字符串
 * @returns {boolean} - 是否为有效 base64
 */
export const isValidBase64 = (str: string) => {
	try {
		return btoa(atob(str)) === str;
	} catch {
		return false;
	}
};

/**
 * 验证是否为有效的 URL
 * @param {string} urlString - 要验证的 URL 字符串
 * @returns {boolean} - 是否为有效 URL
 */
export const isValidUrl = (urlString: string) => {
	try {
		new URL(urlString);
		return true;
	} catch {
		return false;
	}
};

/**
 * 解析设备链接中的设备ID和访问密码
 * @param {string} link - 设备链接
 * @returns {object} - 包含设备ID和访问密码的对象
 */
type InvitePayload = {
	d: string;
	a: string;
	[key: string]: unknown;
};

export const parseDeviceIdAndAccessCodeFromLink = (link: string) => {
	try {
		// 验证是否为有效 URL
		if (!isValidUrl(link)) {
			throw new Error("Please provide a valid invitation link");
		}

		const url = new URL(link);
		const pathParts = url.pathname.split("/").filter((part) => part.length > 0);
		const lastPart = pathParts[pathParts.length - 1];

		if (!lastPart) {
			return;
		}

		// 验证 base64 字符串
		if (!isValidBase64(lastPart)) {
			throw new Error("Invalid invitation link: encoded payload is not valid");
		}

		// 解码 base64 并解析 JSON
		const decodedData = atob(lastPart);
		let parsedData: Partial<InvitePayload> | null = null;

		try {
			parsedData = JSON.parse(decodedData) as Partial<InvitePayload>;
		} catch {
			throw new Error("Invalid invitation link: payload is not valid JSON");
		}

		// 验证必要字段
		if (!parsedData?.d || !parsedData?.a) {
			throw new Error(
				"Invalid invitation link: missing device ID or access code",
			);
		}

		return parsedData;
	} catch (error) {
		console.error("Error parsing device link:", error);
		throw error;
	}
};
